import styled, { css } from 'styled-components';
import { mediaDesktop, mediaTablet } from 'utils/responsive';
import { NexaBlack } from 'utils/styles/typography';

export default styled.h3`
  ${NexaBlack};
  text-transform: uppercase;
  width: 100%;
  padding: 4vh 0;
  font-size: 6vw;
  ${mediaTablet(css`
    font-size: 4vw;
  `)}
  ${mediaDesktop(css`
    font-size: 2.4vw;
  `)}
`;
